<template>
  <form
    name="update-user-permission"
    autocomplete="off"
    @submit.prevent="updateUser"
  >
    <fieldset :disabled="loadingEdit || !editing">
      <div class="emd-panel__section">
        <div class="emd-panel__block">
          <div class="el-chunk">
            <emd-text
              tag="h2"
              size="medium"
              type="caption"
              >{{ $t('users.permission') }}
            </emd-text>
          </div>
        </div>
        <div class="emd-panel__block">
          <div class="el-chunk">
            <role-form-group
              :userRole="role"
              @update:model-value="newValue => (role = newValue)"
            />
          </div>
        </div>
      </div>

      <template v-if="editing">
        <hr class="emd-divider eu-my_4" />
        <password-confirmation
          v-model="password"
          label="invite.create.password-label"
        ></password-confirmation>

        <div class="emd-container__footer eu-no-padding">
          <emd-button
            color="primary"
            type="text"
            type-html="button"
            @click="$emit('cancelEditing')"
            >{{ $t('general.cancel') }}</emd-button
          >
          <emd-button
            :disabled="shouldDisableSubmit"
            color="primary"
            type-html="submit"
          >
            <emd-loader v-if="loadingEdit"></emd-loader>
            <span v-else>{{ $t('general.confirmation') }}</span>
          </emd-button>
        </div>
      </template>
    </fieldset>
  </form>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import PasswordConfirmation from '@/components/project/molecules/PasswordConfirmation.vue'
import { EmdLoader, EmdText, EmdButton } from 'emerald-vue/src/components'
import RoleFormGroup from '@/components/project/ui/RoleFormGroup/Index.vue'
import { formatErrorMessage } from '@/support/formatErrorMessage'

export default {
  name: 'UserFormUpdate',
  props: {
    user: Object,
    editing: Boolean
  },
  components: {
    PasswordConfirmation,
    EmdLoader,
    EmdText,
    EmdButton,
    RoleFormGroup
  },
  data () {
    return {
      password: '',
      loadingEdit: false,
      role: ''
    }
  },
  validations: {
    role: { required }
  },
  computed: {
    ...mapGetters(['accountId']),
    shouldDisableSubmit () {
      return this.$v.role.$invalid || !this.password || this.loadingEdit
    }
  },
  created () {
    this.role = this.user.role
  },
  methods: {
    ...mapActions(['UPDATE_PERMISSION']),
    async updateUser () {
      try {
        if (this.$v.role.$invalid) {
          this.$emit('setAlert', {
            show: true,
            isError: true,
            messages: [this.$t('users.error-required-fields')]
          })
          return
        }

        const params = {
          userId: this.user.id,
          body: {
            type: 'Staff',
            account: {
              account_id: this.accountId,
              role: this.role
            },
            password: window.btoa(this.password)
          }
        }

        this.$emit('resetAlert')
        this.loadingEdit = true

        await this.UPDATE_PERMISSION(params)

        this.loadingEdit = false
        this.password = ''
        this.$emit('getUser')
        this.$emit('setAlert', {
          show: true,
          isError: false,
          messages: [this.$t('users.edit.success')]
        })
        window.scrollTo(0, 0)
      } catch (err) {
        this.loadingEdit = false
        const msgErrorInternal = this.$t('users.error-internal')
        this.$emit('setAlert', {
          show: true,
          isError: true,
          messages: formatErrorMessage(err, msgErrorInternal)
        })
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
